import { useLayoutEffect, useRef } from 'react';
export function useFocusControl(_a) {
    var navigationOpen = _a.navigationOpen, toolsOpen = _a.toolsOpen;
    var navigationToggleRef = useRef(null);
    var navigationCloseRef = useRef(null);
    var toolsToggleRef = useRef(null);
    var toolsCloseRef = useRef(null);
    useLayoutEffect(function () {
        var _a, _b;
        if (navigationOpen) {
            (_a = navigationCloseRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            (_b = navigationToggleRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [navigationOpen]);
    useLayoutEffect(function () {
        var _a, _b;
        if (toolsOpen) {
            (_a = toolsCloseRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            (_b = toolsToggleRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [toolsOpen]);
    return {
        navigationRefs: {
            toggle: navigationToggleRef,
            close: navigationCloseRef
        },
        toolsRefs: {
            toggle: toolsToggleRef,
            close: toolsCloseRef
        }
    };
}
//# sourceMappingURL=use-focus-control.js.map